import { createContext } from 'react';
import type { ButtonSize } from '../Button/primitives';

// Two single-value contexts (one value per provider) so a Button re-renders only
// when the value it consumes changes. `undefined`/`false` defaults mean a standalone
// Button — outside any group — keeps its normal behavior.
export const ButtonGroupSizeContext = createContext<ButtonSize | undefined>(
  undefined
);
export const ButtonGroupDisabledContext = createContext<boolean>(false);
